import { render, staticRenderFns } from "./cbddrinks.vue?vue&type=template&id=2989b85e&scoped=true&"
import script from "./cbddrinks.vue?vue&type=script&lang=js&"
export * from "./cbddrinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989b85e",
  null
  
)

export default component.exports